/* eslint-disable */
/* eslint-disable prefer-template */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Camera, Check, IsClosed, IsOpen, Left, Plus, CircleTimes, View, Times } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { selectWork } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { List, Row, Cell } from '../../../../components/List';
import { selectAllOptions, selectVehicle } from '../../../Vehicles/selectors';
import { addVehicleOption, deleteVehicleProperty, removeVehicleOption, setVehicleProperty } from '../../../Vehicles/actions';
import { ButtonBar } from '../../../../components/ButtonBar';
import _ from 'lodash';
import {
  REQUEST_VEHICLE_PROPERTY_UPDATE,
  WS2_1_EXTRA_PHOTO_NEW,
  WS2_1_GENERAL_PHOTOS,
  WS2_1_IMPORT_PHOTOS_COMMERCIAL,
  WS2_1_IMPORT_PHOTOS_PASSENGER,
  WS2_1_TESLA_ADDITIONAL_PHOTOS,
} from '../../../Vehicles/constants';
import { COLOR_BG_LIGHT, COLOR_PRIMARY_1, COLOR_SECONDARY_1 } from '../../../../vars';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { addDocument, deleteDocument } from '../../../Documents/actions';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { TireData } from '../../../Vehicles/components/TireData';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import { parseISO } from 'date-fns';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { UserLabelById } from '../../../Users/components/UserLabelById';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Cell as ActionCell } from '../Cell';
import { resizeAndRotate } from '../../../../utils/image';
import { getPropByName } from '../../../../utils/props';
import { getVehicleAge } from '../../../Vehicles/helpers';

import { Dropdown } from 'bootstrap';
import cn from 'classnames';

import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import styles from './WS_Default.module.css';
import { VehicleCopyOptionsModal } from '../../../Vehicles/components/CopyOptionsModal';
import {
  optionsList_inspection,
  optionsList_inspectionPart1,
  optionsList_inspectionPart2,
  optionsList_inspectionPart3,
  optionsList_inspectionPart4,
  clientId,
} from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { isMobileDevice } from '../../../../utils/checkDevice';

dayjs.extend(customParseFormat);

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const Subtitle = styled.h3`
  width: 100%;
  background: #eff1f7;
  font-weight: bold;
  padding: 4px;
  font-size: 14px;
`;

const StateToggler = styled.div`
  min-height: 24px;
  width: ${props => (props.small ? '110px' : '160px')};
  border-radius: 12px;
  background-color: ${({ isActive }) => (!!isActive ? 'var(--color-new-secondary)' : '#fa5c7c')};
  color: white;
  font-weight: bold;
  padding: 0 2px;
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 0;
`;
const PhotoWrapper = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => (props.isActive ? 'white' : 'grey')};
  background-color: ${props => (props.isActive ? 'var(--color-new-secondary)' : 'var(--color-new-white)')};
`;

const Container = styled.div`
  .modal-inner {
  }

  .option {
    align-items: baseline;
    &.inactive {
      opacity: 0.5;
    }
  }

  .grid-container {
    width: 100%;
    display: grid;
    grid-template-columns: 49% 49%;
    gap: 10px;

    @media (max-width: 560px) {
      grid-template-columns: 100%;
    }

    .cell {
      margin: 5px;
      background-color: ${COLOR_BG_LIGHT};
      color: #808185;
      font-weight: 600;
      text-align: center;
      padding: 10px 0;
      border-radius: 0.375rem;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    }
  }

  .import-photo-wrapper {
    justify-content: space-between;
    height: 164px;
  }
  .pane {
    border-top: 1px solid #eee;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 18px;
    }
  }

  .optionPhoto {
    position: fixed;
    background-color: black;
    z-index: 99999;

    .img {
      position: absolute;
      top: 90px;
      left: 10px;
      right: 10px;
      bottom: 10px;
      background-size: contain;
      background-position: center center;
    }
  }
  .options-list {
    .title {
      font-weight: 600;
      /* margin-top: 12px; */
      font-size: 1.2rem;
      border-bottom: 1px solid #ddd;
      width: 100%;
      margin-bottom: 3px;
    }
  }
  .image-available {
    width: 40px;
    height: 40px;
    background-color: #00bfae;
    color: white;
    border-radius: 40px;
    text-align: center;
    margin-right: 3px;
    padding-top: 1px;
    padding-top: 5px;

    .icon {
      margin: 0;
      padding: 0 0;
    }
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      width: 24px;
      height: 24px;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      display: flex;
      align-items: stretch;
      justify-content: center;
      background-color: #0183d5;
      color: #fff;
      border-radius: 0.375rem;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        background-color: var(--color-new-secondary);
      }
    }
    &.triple-2 {
      .check {
        background-color: #fa5c7c;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
  }

  .tire_set {
    > .box {
      max-width: 330px;
    }
    .tire-depth-container {
      width: 100%;
      .button {
        width: 60px;
        margin: 1px;
        align-self: stretch;
      }
    }

    .vehicle-property-loadable {
      max-width: 300px;
      &.loading {
        opacity: 0.2;
      }
    }
  }

  .attention-img {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    background-size: contain;
    border: 1px solid #eee;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }

  .thumb {
    background-color: #eeeeee6e;
  }

  .import-img {
    width: 190px;
    height: 120px;
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;
    .add {
      width: 100px;
      height: 100px;
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const STATE = {
  approve: false,
  options: false,
  manco: false,
  attention: false,
  regplate_code: '',
  date_last_maintenance: '',
  mileage_last_maintenance: '',
  date_timing_belt_change: '',
  mileage_timing_belt_change: '',
  mileage: '',
  showCopyOptionsModal: false,
  showCopyPhotosModal: false,
};

/* eslint-disable react/prefer-stateless-function */
class WS2_1_InteriorComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    const comments = this.comments;

    this.setState({ ...comments, mileage: getPropByName(this.vehicle, 'mileage') });
    ['date_last_maintenance', 'date_timing_belt_change'].map(name => {
      let val = this.vehicle?.[name];
      if (val) {
        this.setState({ [name]: val });
      }
    });
  }

  get comments() {
    const comments = this.vehicle?.properties
      ?.filter(p => p?.propertyName?.name?.startsWith('attention_comment_'))
      ?.reduce(
        (acc, prop) => ({
          ...acc,
          [prop?.propertyName?.name]: prop?.propertyValue?.value,
        }),
        {},
      );

    return comments;
  }

  componentDidUpdate(prevProps, prevState) {
    ['date_last_maintenance', 'date_timing_belt_change'].map(name => {
      let val = this.vehicle?.[name];
      if (val && !this.state[name]) {
        this.setState({ [name]: val });
      }
      if (val == this.state?.[name]) {
        this.setState({ [`saveDate_${name}`]: false });
      }
    });
  }

  closeBootstrapDropdown(e) {
    const dropdownElement = e.target.closest('.dropdown');
    const bsDropdown = Dropdown.getInstance(dropdownElement) || new Dropdown(dropdownElement);
    bsDropdown.hide();
  }

  reset() {
    // if (dontCloseModal) {
    //   this.setState(prev => ({ ...STATE, approve: prev.approve }));
    //   return;
    // }
    this.setState({ ...STATE });
  }

  static getDerivedStateFromProps(props, state) {
    ['date_last_maintenance', 'mileage_last_maintenance', 'date_timing_belt_change', 'mileage_timing_belt_change'].map(
      name => {
        let val = props.cell?.vehicle[name];
        if (val) {
          if (val.updatedAt != state[name + '_updatedAt']) {
            state[name + '_updatedAt'] = val.updatedAt;
            state[name] = val.propertyValue.value;
          }
        } else {
        }
      },
    );
    return state;
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.vehicle[name];
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  get buttonLabel() {
    let label = '';
    switch (env.clientId) {
      case AppClientId.HOOIKAMMER:
        label = 'HOOI_interior_inspection';
      case AppClientId.AUTOWIENTJES:
        label = 'WIENTJES_inspecteren';
      default:
        label = 'WS2_1_Interior';
    }

    return label;
  }

  get tripleCheckProps() {
    let props = [
      'has_instruction_book',
      'has_maintenance_book',
      'has_headrests',
      'has_hatrest',
      'baggage_cover',
      'has_charge_cable_230v',
      'has_charge_cable_380v',
      'has_charge_port',
      'has_key_lift',
      'has_key_cabinet_fitting',
    ];

    return props;
  }

  get tripleCheckProps1() {
    let props = ['has_instruction_book', 'has_maintenance_book'];

    if (getVehicleAge(this.vehicle?.date_first_allowance) <= 7 && this.vehicle?.brand_name?.toLowerCase() == 'kia') {
      props.push('warranty_sticker');
    }

    return props;
  }

  get tripleCheckProps2() {
    let props = ['has_charge_cable_230v', 'has_charge_cable_380v', 'has_headrests', 'has_hatrest', 'baggage_cover'];

    return props;
  }
  get tripleCheckProps3() {
    let props = ['has_key_lift', 'has_key_cabinet_fitting'];

    return props;
  }

  requiredOption() {
    const reqProps = ['warranty_sticker'];
    const isReq = this.tripleCheckProps?.filter(type => reqProps?.includes(type));

    return isReq;
  }

  generatePayload() {
    return this.state?.changed ?? {};
  }

  applyDisabled() {
    let isRequired = false;
    this.tripleCheckProps?.map(type => {
      if (this.requiredOption()?.includes(type) && this.vehicle[type] == 0) {
        isRequired = true;
      }
      return this.state?.changed ?? {};
    });

    return isRequired;
  }

  capture(name, callback) {
    //remove existing image upload
    document.getElementById('image-upload')?.remove();

    let input = document.createElement('input');
    input.type = 'file';
    input.name = 'image';
    input.id = 'image-upload';
    input.accept = 'image/*';
    // input.setAttribute('capture', 'camera');

    // if (isMobileDevice()) {
    //   input.setAttribute('capture', 'environment');
    // }

    document.body.appendChild(input);

    input.click();

    input.addEventListener(
      'change',
      this.callback(evt => {
        resizeAndRotate(evt.target.files[0]).then(file => {
          this.props.imageUpload(
            {
              name,
              type: 'photo_interior_' + name,
              originalFilename: 'originalFilename',
              file,
            },
            'upload_' + name,
          );

          callback?.();

          try {
            evt.target.removeEventListener(evt.target, this._evtListener);
            evt.target.remove();
          } catch (e) {}
        });
      }),
    );
  }

  toggleOption(id, state) {
    this._lastOption = id;

    //todo: busy_ ... is depricated
    this.setState(
      { [`busy_${id}`]: true },
      this.props.toggleOption(id, state, result => {
        this.setState({ [`busy_${id}`]: false });
      }),
    );
  }

  renderPane(name, title, content) {
    return (
      <>
        <div className="d-flex w-100">
          <div
            className={cn(styles.accordionHeader, { [styles.openAccordionHeader]: this.state[name] })}
            onClick={this.setStateFn({ [name]: !this.state[name] })}
          >
            {title}
          </div>
          <div
            className={cn(styles.accordionIcon, { [styles.openAccordionIcon]: this.state[name] })}
            onClick={this.setStateFn({ [name]: !this.state[name] })}
          >
            {this.state[name] ? <IsClosed /> : <IsOpen />}{' '}
          </div>
        </div>
        {this.state[name] ? content : null}
      </>
    );
  }

  renderFormField(name, type) {
    let ISO;
    if (type == 'date') {
      let date = this.state[name];
      try {
        ISO = date ? parseISO(dayjs(date, 'DD-MM-YYYY').format('YYYY-MM-DD')) : null;
        if (ISO == 'Invalid Date') ISO = null;
      } catch (error) {
        debugger;
      }
    }

    return (
      <div key={name}>
        <label className="form-label">{this.lbl('vehicle.property.' + name)}</label>
        <VehiclePropertyLoadable name={name}>
          {type == 'date' ? (
            <HBox left vBottom>
              <DatePicker
                className={styles.datePicker}
                dateFormat="dd-MM-yyyy"
                selected={this.state[name] ? ISO : ''}
                onChange={val => {
                  val = dayjs(val).format('DD-MM-YYYY');

                  this.setState({ [name]: val, [`saveDate_${name}`]: true });
                }}
              />
              {this.state[`saveDate_${name}`] && (
                <Button
                  small
                  onClick={() => {
                    this.props.setProperty(name, this.state[name]);
                    this.setState({ [`saveDate_${name}`]: false });
                  }}
                >
                  <Check />
                </Button>
              )}
            </HBox>
          ) : (
            <input
              className="form-control"
              type={type}
              value={this.state[name]}
              onChange={this.onInputChange.bind(this)}
              name={name}
              key={name}
              onBlur={() => {
                this.props.setProperty(name, this.state[name]);
              }}
            />
          )}
        </VehiclePropertyLoadable>
      </div>
    );
  }

  renderOption(value, index) {
    if (value.title)
      return (
        <div className="title" key={index}>
          {this.lbl(`vehicle.options.${value.title}`)}
        </div>
      );

    let option = this.props.allOptions?.find(o => o.name.toLowerCase() == value.toLowerCase());

    let vehicleHasOption = this.vehicle.options?.find(
      o =>
        (typeof o?.name === 'string' ? o?.name.toLowerCase() : '') ===
          (typeof value === 'string' ? value.toLowerCase() : '') && !!o?.VehicleHasOption?.isSelected,
    );

    let checked_name = `checked_${value}`;

    let checked = this.state[checked_name] || vehicleHasOption;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + value);

    let name = `vehicle-option-${option?.id}`;

    return (
      <HBox vCenter key={index} className={`option ${!option ? 'inactive' : ''} option-${option?.id}`}>
        <div className={styles.checkboxContainer}>
          <VehiclePropertyLoadable name={name}>
            <CheckboxComponent
              label={value}
              checked={checked}
              onChange={option ? () => this.toggleOption(option.id, !checked) : null}
            />
          </VehiclePropertyLoadable>
        </div>
        <VehiclePropertyLoadable name={`upload_${value}`}>
          {photo ? (
            <div
              className={cn('pointer', styles.imageAvailable)}
              onClick={() => {
                let container = document.getElementsByClassName('modal-inner')[0];
                let renderOptionPhotoDims = container.getBoundingClientRect();
                this.setState({
                  renderOptionPhoto: photo.id,
                  renderOptionPhotoDims,
                });
              }}
            >
              <Camera />
            </div>
          ) : (
            <div onClick={this.setStateFn({ optionPhoto: option?.id })} className={cn('pointer', styles.buttonCamera)}>
              <Camera
                className={styles.icon}
                onClick={() =>
                  this.capture(
                    value,
                    this.callback(() => this.props.toggleOption(option.id, true)),
                  )
                }
              />
            </div>
          )}
        </VehiclePropertyLoadable>
      </HBox>
    );
  }

  handlePhotoDelete = documentId => {
    if (confirm()) {
      const group = this.vehicle.documents?.find(d => d.id === documentId)?.type;
      if (this.vehicle.documents?.filter(d => d?.type === group)?.length === 1) {
        const index = group?.slice(25);
        this.setState({ [`attention_comment_${index}`]: '' });
        this.props.deleteProperty(`attention_comment_${index}`);
        this.props.deleteProperty(`attention_repaired_${index}`);
        this.props.deleteProperty(`attention_displayed_${index}`);
      }
      this.props.deleteDocument(documentId, this.setStateFn({ renderOptionPhoto: null }));
    }
  };

  renderOptionPhoto() {
    if (!this.state.renderOptionPhoto) return null;

    let document = this.vehicle.documents?.find(document => document.id == this.state.renderOptionPhoto);

    return (
      <div
        onClick={this.setStateFn({ renderOptionPhoto: null })}
        className="optionPhoto"
        style={{
          width: Math.ceil(this.state.renderOptionPhotoDims.width) + 'px',
          height: this.props.vehicleDetails ? Math.ceil(this.state.renderOptionPhotoDims.height) + 'px' : '100%',
          left: Math.ceil(this.state.renderOptionPhotoDims.x) + 'px',
          top: 0,
          // top: Math.ceil(this.state.renderOptionPhotoDims.y) + 'px',
        }}
      >
        <div
          className="img"
          style={{ backgroundImage: `url('${encodeURI(decodeURI(document.url)).replace(/%5C/g, '/')}')` }}
        ></div>
        <HBox>
          <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.setStateFn({ renderOptionPhoto: null })}>
            <Left /> {this.lbl('back')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.handlePhotoDelete(document.id)}>
            <Times />
            {this.lbl('delete')}
          </ButtonComponent>
        </HBox>
      </div>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent
        onClose={() => this.reset()}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        <Container className="modal-inner">
          <WithVehicle loader vehicle_id={this.vehicle.id}>
            {this.showCopyOptionsModal()}
            {this.showCopyPhotosModal()}
            {this.renderModalBody()}
          </WithVehicle>
        </Container>
      </ModalComponent>
    );
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + name);
    const required = this.requiredOption()?.includes(name) && val == 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
        >
          <div className={cn('label', styles.labelCamera)}>{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              {/* <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>Todo</label> */}

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>
                Aanwezig
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio3-${name}`}
                autoComplete="off"
                checked={state == 2}
                onChange={() => this.props.setProperty(name, 2)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>
                Manco
              </label>
            </div>
          </VehiclePropertyLoadable>

          {required && <RequireMark>*</RequireMark>}
        </div>

        {photo ? (
          <div
            className={cn('pointer image-available', styles.buttonCamera)}
            onClick={() => {
              let container = document.getElementsByClassName('modal-inner')[0];
              let renderOptionPhotoDims = container.getBoundingClientRect();
              this.setState({
                renderOptionPhoto: photo.id,
                renderOptionPhotoDims,
              });
            }}
          >
            <Camera />
          </div>
        ) : (
          <div onClick={this.setStateFn({ optionPhoto: name })} className={cn('pointer', styles.buttonCamera)}>
            <VehiclePropertyLoadable name={name}>
              <Camera
                onClick={() =>
                  this.capture(
                    name,
                    this.callback(() => this.props.setProperty(name, 1)),
                  )
                }
              />
            </VehiclePropertyLoadable>
          </div>
        )}
      </HBox>
    );
  }

  renderTireBlock(n) {
    let name = 'tire_set_' + n;
    let value = this.propertyValue(name);
    if (!value) return null;

    let values = value.split(':');
    let i = 0;
    let mapped = {
      weather: values[i++],
      material: values[i++],
      size: values[i++],
      lf: values[i++],
      rf: values[i++],
      lb: values[i++],
      rb: values[i++],
    };

    const setValue = function(tName, tValue) {
      mapped[tName] = tValue;
      let value = '';
      this.props.setProperty(
        name,
        mapped.weather +
          ':' +
          mapped.material +
          ':' +
          mapped.size +
          ':' +
          mapped.lf +
          ':' +
          mapped.rf +
          ':' +
          mapped.lb +
          ':' +
          mapped.rb,
      );
    }.bind(this);

    return (
      <VBox className={`tire_set ${this.props.work ? 'disabled' : ''}`} key={`tire-block-${n}`}>
        <VehiclePropertyLoadable hideChildrenOnLoad={false} name={name}>
          <label className="form-label">{this.lbl('vehicle.property.tire_set.weather')}</label>
          <div className={cn('d-flex btn-group gap-2 mb-2', styles.buttonGroup)} role="group" aria-label="Basic example">
            {['summer', 'winter', 'all'].map(s => (
              <Button
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: mapped.weather === s,
                })}
                onClick={() => setValue('weather', s)}
                small={window.innerWidth < 425}
                key={s}
              >
                {this.lbl('vehicle.property.tire_set.weather.' + s)}
              </Button>
            ))}
          </div>
          <label className="form-label">{this.lbl('vehicle.property.tire_set.material')}</label>
          <div className={cn('d-flex btn-group gap-2 mb-2', styles.buttonGroup)} role="group" aria-label="Basic example">
            {['alu', 'steel', 'other'].map(name => (
              <Button
                className={cn(styles.buttonGroupItem, {
                  [styles.selectedButton]: mapped.material == name,
                })}
                onClick={() => setValue('material', name)}
                small={window.innerWidth < 425}
                key={name}
              >
                {this.lbl('vehicle.property.tire_set.material.' + name)}
              </Button>
            ))}
          </div>
          <label className="form-label">Inch:</label>

          <div className="dropdown">
            <button
              className={cn('btn btn-secondary dropdown-toggle', styles.buttonToggle)}
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              role="button"
            >
              {mapped.size}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              {_.times(15, n => (
                <li key={n}>
                  <a
                    disabled={this.props.work}
                    onClick={e => {
                      setValue('size', 12 + n);
                      this.closeBootstrapDropdown(e);
                    }}
                    className="dropdown-item"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    {12 + n}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.gridContainerTire}>
            {['lf', 'rf', 'lb', 'rb'].map(name => (
              <VBox className="mb-2" key={name}>
                <label className="form-label">{this.lbl('vehicle.property.tire_set.' + name)}</label>
                <div className="dropdown">
                  <button
                    className={cn('btn btn-secondary dropdown-toggle', styles.buttonToggle)}
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    role="button"
                  >
                    {mapped[name]}
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    {_.times(10, n => (
                      <li key={`${name}-${n + 1}`}>
                        <a
                          disabled={this.props.work}
                          onClick={e => {
                            setValue(name, n + 1);
                            this.closeBootstrapDropdown(e);
                          }}
                          className="dropdown-item"
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                        >
                          {n + 1}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </VBox>
            ))}
          </div>
        </VehiclePropertyLoadable>
      </VBox>
    );
  }

  addAttentionImage(index, isNewGroup = false) {
    this.capture('attention_' + index);
    if (isNewGroup) {
      this.props.setProperty(`attention_repaired_${index}`, 0);
      this.props.setProperty(`attention_displayed_${index}`, 1);
      this.props.setProperty(`attention_comment_${index}`, '');
    }
  }

  renderAttentionPhoto(document) {
    return (
      <div key={`attention-${document.id}`}>
        <div
          className="attention-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ backgroundImage: `url('${encodeURI(decodeURI(document.url)).replace(/%5C/g, '/')}')` }}
        ></div>
      </div>
    );
  }

  addImportImage(index, type, option) {
    if (option == 'generalPhotos') {
      this.capture('general_' + index + ' ' + type);
    } else {
      this.capture('import_' + index + ' ' + type);
    }
  }

  renderNewPhoto(option) {
    const v = this.props.vehicle;
    let photoIndex = option == 'generalPhotos' ? 'photo_interior_general_0' : 'photo_interior_import_0';

    if (!v) return null;
    if (!this.state.mileage) {
      this.setState({ mileage: getPropByName(v, 'mileage') });
    }
    const vehiclePurpose = getPropByName(this.vehicle, 'vehicle_purpose');
    let extraPhotos = [];
    let defaults = [];
    let rows = [];

    defaults = WS2_1_EXTRA_PHOTO_NEW;

    defaults?.map((type, i) => {
      let photos = v.documents?.filter(d => {
        return d?.type?.indexOf(`${photoIndex} ${type}`) === 0;
      });

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });

    return (
      <>
        <div key="import_photos" className="grid-container">
          {rows.map(row => {
            return (
              <div key={row?.placeholder}>
                <div className="cell">
                  {row?.photos?.length > 0 ? (
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc))}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  ) : (
                    <VBox
                      center
                      className="import-photo-wrapper"
                      onClick={() => {
                        this.addImportImage(0, row.placeholder, option);
                      }}
                    >
                      {this.renderPlaceholderImage(vehiclePurpose, row?.placeholder, option)}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  )}
                </div>
              </div>
            );
          })}
          {option == 'generalPhotos' && (
            <div class="cell">
              <HBox
                vCenter
                className="import-photo-wrapper extra-photo-wrapper"
                onClick={() => this.addImportImage(0, `extra_${extraPhotos?.length}`, option)}
              >
                <div style={{ fontSize: '26px' }}>
                  <Plus />
                </div>
              </HBox>
            </div>
          )}
        </div>
      </>
    );
    return null;
  }

  renderImportPhoto(document) {
    return (
      <div key={`import-${document.id}`}>
        <div
          className="import-img"
          onClick={() => {
            let container = window.document.getElementsByClassName('modal-inner')[0];
            let renderOptionPhotoDims = container.getBoundingClientRect();
            this.setState({
              renderOptionPhoto: document.id,
              renderOptionPhotoDims,
            });
          }}
          style={{ opacity: '0.7', backgroundImage: `url('${encodeURI(decodeURI(document.url)).replace(/%5C/g, '/')}')` }}
        ></div>
      </div>
    );
  }

  renderInspectionProperty(name, hasPhoto = false) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    let photo = this.vehicle.documents?.find(document => document.type == 'photo_interior_' + name);
    const isOk = state === 1;
    return (
      !!state && (
        <Row className={styles.row} key={name}>
          {this.renderOptionPhoto()}
          <Cell className={styles.cell1}>
            <VBox left>
              {this.lbl(`vehicle.property.${name}`)}
              <strong>{this.vehicle[`${name}_comment`]}</strong>
            </VBox>
          </Cell>
          {!!hasPhoto && (
            <Cell className={styles.cell3}>
              <PhotoWrapper
                isActive={!!photo}
                className={cn('pointer image-available', styles.buttonCameraPhoto)}
                onClick={() => {
                  if (!!photo) this.handleOpenPhoto(photo);
                }}
              >
                <Camera />
              </PhotoWrapper>
            </Cell>
          )}
          <Cell className={styles.cell2}>
            <StateToggler isActive={isOk} small={hasPhoto}>
              <FontAwesomeIcon icon={isOk ? faCheckCircle : faTimesCircle} style={{ width: 22, marginRight: 5 }} />
              {hasPhoto
                ? isOk
                  ? this.lbl('vehicle.inspection.present')
                  : this.lbl('vehicle.inspection.flaw')
                : isOk
                ? this.lbl('vehicle.inspection.checked')
                : this.lbl('vehicle.inspection.failed')}
            </StateToggler>
          </Cell>
        </Row>
      )
    );
  }

  renderPlaceholderImage(vehiclePurpose, type, option) {
    if (option == 'generalPhotos') {
      return (
        <div key={type}>
          <div
            className="import-img"
            style={{
              opacity: '0.7',
              backgroundImage: `url('/public/images/ws2_1_interior_defaults/general/${type}.jpg')`,
            }}
          ></div>
        </div>
      );
    }

    if (option === 'tesla_additional_info') {
      return (
        <div key={type}>
          <div
            className="import-img"
            style={{
              opacity: '0.7',
              backgroundImage: `url('/public/images/ws2_1_interior_defaults/tesla/${type}.png')`,
            }}
          ></div>
        </div>
      );
    }
    return (
      <div key={type}>
        <div
          className="import-img"
          style={{
            backgroundImage: `url('/public/images/ws2_1_interior_defaults/${vehiclePurpose}/${type}.png')`,
          }}
        ></div>
      </div>
    );
  }

  showCopyOptionsModal() {
    if (!this.state.showCopyOptionsModal) return;
    return (
      <VehicleCopyOptionsModal vehicleId={this.vehicle?.id} close={() => this.setState({ showCopyOptionsModal: false })} />
    );
  }

  showCopyPhotosModal() {
    if (!this.state.showCopyPhotosModal) return;
    return (
      <VehicleCopyOptionsModal
        copy_photos
        vehicleId={this.vehicle?.id}
        close={() => this.setState({ showCopyPhotosModal: false })}
      />
    );
  }

  renderModalBody() {
    const vehicle = this.vehicle;
    return (
      <>
        <VBox key="body">
          {this.renderOptionPhoto()}
          {this.renderPane(
            'purchase-data',
            this.lbl('interior.inspection.purchase-data'),
            <>
              <List className={styles.listItem}>
                <Row className={styles.row}>
                  <Cell className={styles.cell1}>{this.lbl(`vehicle.property.creditor_company`)}</Cell>
                  <Cell className={styles.cell2}>
                    <CompanyLabelById company_id={this.vehicle.creditor_company} />
                  </Cell>
                </Row>

                <Row className={styles.row}>
                  <Cell className={styles.cell1}>{this.lbl(`vehicle.property.buying_company`)}</Cell>
                  <Cell className={styles.cell2}>
                    <CompanyLabelById company_id={this.vehicle.buying_company} />
                  </Cell>
                </Row>

                <Row className={styles.row}>
                  <Cell className={styles.cell1}>{this.lbl(`vehicle.property.buying_contact`)}</Cell>
                  <Cell className={styles.cell2}>
                    <UserLabelById user_id={this.vehicle.buying_contact} />
                  </Cell>
                </Row>
              </List>
              <br />
            </>,
          )}

          {/* {this.renderPane(
            'testdrive-data',
            this.lbl('vehicle.inspection.technical'),
            <>
              <List>
                {[
                  'state_engine_general',
                  'state_ac',
                  'state_brakes',
                  'state_transmission',
                  'state_drive',
                  'state_electrics',
                ].map(property => this.renderInspectionProperty(property))}
              </List>
              <br />
            </>,
          )} */}

          {this.renderPane(
            'options',
            this.lbl('interior.inspection.options'),
            <VBox className="options-list" key="options">
              <VBox gap={'4px'}>
                <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => this.setState({ showCopyOptionsModal: true })}>
                  {' '}
                  {this.lbl('vehicle.copy_options')}
                </ButtonComponent>

                <ButtonComponent style={'ButtonSoftPrimary'} onClick={() => this.setState({ showCopyPhotosModal: true })}>
                  {' '}
                  {this.lbl('vehicle.copy_photos')}
                </ButtonComponent>
              </VBox>

              {clientId === AppClientId.INDEWAL ? (
                <>
                  {optionsList_inspectionPart1?.map(this.renderOption.bind(this))}
                  {this.tripleCheckProps1?.map(name => this.renderTripleCheck(name))}
                  <div className="mb-2 mt-2">
                    {[
                      ['mileage_last_maintenance', 'number'],
                      ['mileage_timing_belt_change', 'number'],
                    ].map(pair => this.renderFormField(pair[0], pair[1]))}
                  </div>
                  {optionsList_inspectionPart2?.map(this.renderOption.bind(this))}
                  {this.tripleCheckProps2?.map(name => this.renderTripleCheck(name))}
                  {vehicle.vehicle_purpose != 'passenger' && optionsList_inspectionPart4?.map(this.renderOption.bind(this))}
                  {optionsList_inspectionPart3?.map(this.renderOption.bind(this))}
                  {vehicle.vehicle_purpose != 'passenger' &&
                    this.tripleCheckProps3?.map(name => this.renderTripleCheck(name))}
                </>
              ) : (
                <>{optionsList_inspection?.map(this.renderOption.bind(this))}</>
              )}
            </VBox>,
          )}
          {this.renderPane(
            'manco',
            this.lbl('interior.inspection.manco'),
            <VBox className="manco-list" key="manco">
              <div>
                {this.lbl('vehicle.property.num_keys')}
                <HBox left>
                  <VehiclePropertyLoadable name="num_keys">
                    <div className={styles.containerButtonBar}>
                      <ButtonBar>
                        {_.times(5, num => {
                          num += 1;
                          return (
                            <Button
                              className={styles.buttonBarItem}
                              key={num}
                              small
                              disabled={this.props.work}
                              primary={num == this.propertyValue('num_keys')}
                              onClick={() => {
                                this.props.setProperty('num_keys', num);
                              }}
                            >
                              {num}
                            </Button>
                          );
                        })}
                      </ButtonBar>
                    </div>
                  </VehiclePropertyLoadable>
                </HBox>
              </div>
              {clientId === !AppClientId.INDEWAL && (
                <>
                  {' '}
                  {this.tripleCheckProps1?.map(name => this.renderTripleCheck(name))}
                  {this.tripleCheckProps2?.map(name => this.renderTripleCheck(name))}
                  {vehicle.vehicle_purpose != 'passenger' &&
                    this.tripleCheckProps3?.map(name => this.renderTripleCheck(name))}
                </>
              )}
              <div className="title">
                <h6>{this.lbl('interior.inspection.maintenance')}</h6>

                {[
                  {
                    key: 'date_last_maintenance',
                    label: this.lbl('vehicle.property.date_last_maintenance'),
                  },
                  {
                    key: 'mileage_last_maintenance',
                    label: this.lbl('vehicle.property.mileage_last_maintenance'),
                  },
                  {
                    key: 'date_timing_belt_change',
                    label: this.lbl('vehicle.property.date_timing_belt_change'),
                  },
                  {
                    key: 'mileage_timing_belt_change',
                    label: this.lbl('vehicle.property.mileage_timing_belt_change'),
                  },
                ].map((field, index) => (
                  <FormField key={`import-input-${index}`} label={field.label}>
                    <Input
                      full
                      key={field.key}
                      name={field.key}
                      onChange={this.onCommentChange}
                      value={this.state[field.key]}
                      rightDecoration={
                        <>
                          <Button
                            small
                            disabled={this.props.workUpdate}
                            onClick={() => {
                              this.props.setProperty(field.key, this.state[field.key]);
                            }}
                          >
                            {this.props.workUpdate ? <Loader small="true" /> : <Check />}
                          </Button>
                          <Button
                            warning
                            disabled={this.props.workUpdate}
                            small
                            onClick={() => {
                              this.props.deleteProperty(field.key);
                              this.setState({ [field.key]: '' });
                            }}
                          >
                            {this.props.workUpdate ? <Loader small="true" /> : <Times />}
                          </Button>
                        </>
                      }
                    />
                  </FormField>
                ))}
              </div>

              <div className="title">
                <h6>{this.lbl('interior.inspection.tires')}</h6>
              </div>
              {_.times(10, this.renderTireBlock.bind(this))}
              <div className="mt-2 mb-2">
                <ButtonComponent
                  style={'ButtonSoftPrimary'}
                  disabled={this.props.work}
                  onClick={() => {
                    for (let i = 0; i < 10; i++) {
                      if (!this.propertyValue('tire_set_' + i)) {
                        this.props.setProperty('tire_set_' + i, 'summer:alu:11:0:0:0:0');
                        return;
                      }
                    }
                  }}
                >
                  <Plus /> {this.lbl('add')}
                </ButtonComponent>
              </div>
            </VBox>,
          )}
          {this.renderPane(
            'attention',
            this.lbl('interior.inspection.attention'),

            <VBox className="attention" key="attention">
              {this.renderAttention()}

              {this.vehicle.documents
                ?.filter(document => document.type == 'photo_interior_attention')
                .map(this.renderAttentionPhoto.bind(this))}
            </VBox>,
          )}
          {clientId === AppClientId?.INDEWAL &&
            this.vehicle?.brand_name?.toLowerCase() === 'tesla' &&
            this.renderPane(
              'tesla_additional_info',

              <h1>{this.lbl('interior.inspection.tesla_additional_info')}</h1>,
              <VBox className="import_photo" key="import_photo">
                {this.renderImportPhotos('tesla_additional_info')}

                {this.vehicle.documents
                  ?.filter(document => document.type == 'photo_interior_import')
                  .map(this.renderImportPhoto.bind(this))}
              </VBox>,
            )}
          {this.renderPane(
            'import_photo',
            this.vehicle?.vehicle_purpose
              ? this.lbl('interior.inspection.import_photo')
              : this.lbl('interior.inspection.no_vehicle_type'),

            this.vehicle?.vehicle_purpose && (
              <VBox className="import_photo" key="import_photo">
                {this.renderImportPhotos()}

                {this.vehicle.documents
                  ?.filter(document => document.type == 'photo_interior_import')
                  .map(this.renderImportPhoto.bind(this))}
              </VBox>
            ),
          )}

          {this.vehicle?.regplate && this.vehicle?.mileage && this.vehicle.mileage < 3000
            ? this.renderPane(
                'extra_photos',
                this.vehicle?.regplate && this.vehicle?.mileage && this.vehicle.mileage < 3000 ? (
                  <h6 style={{ color: 'red' }}>{this.lbl('interior.inspection.extra_photos_new')}</h6>
                ) : (
                  <h5>{this.lbl('interior.inspection.not_neccesary')}</h5>
                ),

                this.vehicle?.regplate && (
                  <VBox className="import_photo" key="import_photo">
                    {this.renderNewPhoto()}

                    {this.vehicle.documents
                      ?.filter(document => document.type == 'photo_interior_import')
                      .map(this.renderImportPhoto.bind(this))}
                  </VBox>
                ),
              )
            : null}

          {this.renderPane(
            'general_photo',

            this.lbl('interior.inspection.general_photo'),

            <VBox className="import_photo" key="import_photo">
              {this.renderImportPhotos('generalPhotos')}

              {this.vehicle.documents
                ?.filter(document => document.type == 'photo_interior_general')
                .map(this.renderImportPhoto.bind(this))}
            </VBox>,
          )}
        </VBox>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            className={styles.confirmButton}
            disabled={this.applyDisabled()}
            action={this.props.action}
            target={this.vehicle}
            onChange={() => this.reset(true)}
          />
          <ButtonComponent style={'ButtonSoftDelete'} disabled={this.props.workAction} onClick={() => this.reset()}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    if (!vehicle || !this.props.allOptions) return <Loader small />;

    if (this.props.vehicleDetails)
      return (
        <Container>
          <HBox right className="mt-2">
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <Button
                  style={'ButtonSoftPrimary'}
                  size={'btn-sm'}
                  onClick={this.setStateFn({
                    approve: !this.state.approve,
                    regplate_code: vehicle.regplate_code || '',
                  })}
                >
                  Inspectie uitvoeren
                </Button>
              </>
            )}
          </HBox>
          {this.renderApprove()}
        </Container>
      );

    return (
      <ActionCell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <Label count={vehicle?.walstreetdoorlooptijdfix_counter} ranges={ranges}>
            {vehicle?.walstreetdoorlooptijdfix_counter || '0'}
          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }

  onCommentChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  renderAttention() {
    const v = this.props.vehicle;

    if (!v) return null;

    let rows = [];

    for (let i = 0; i < 100; i++) {
      let photos = v.documents?.filter(d => {
        return d.type?.indexOf(`photo_interior_attention_${i}`) === 0;
      });

      if (!photos?.length) continue;
      rows[i] = {
        index: i,
        photos,
      };
    }

    return (
      <VBox key="attentions">
        {rows.map(row => (
          <VBox>
            <HBox flexWrap left key={`attention-row-${row.index}`}>
              {row.photos.map(d => this.renderAttentionPhoto(d))}
              {row.photos?.length < 4 && (
                <div className="thumb attention-img">
                  <VBox className="add" center vCenter onClick={() => this.addAttentionImage(row.index)}>
                    <Plus />
                  </VBox>
                </div>
              )}
            </HBox>
            <HBox>
              <div key={`attention-input-${row.index}`} className={styles.buttonGroupCheck}>
                <div className={styles.input}>
                  {' '}
                  {this.props.workUpdate ? (
                    <Loader small />
                  ) : (
                    <VehiclePropertyLoadable name={`attention-comment-${row.index}`}>
                      <input
                        className="form-control"
                        key={`attention-comment-${row.index}`}
                        name={`attention_comment_${row.index}`}
                        onFocus={() => {
                          this.setState({ [`attention_comment_${row.index}`]: v?.[`attention_comment_${row.index}`] });
                        }}
                        onChange={this.onCommentChange}
                        onBlur={() => {
                          this.props.setProperty(
                            `attention_comment_${row.index}`,
                            this.state[`attention_comment_${row.index}`],
                          );
                        }}
                        value={
                          Object.hasOwn(this.state, `attention_comment_${row.index}`)
                            ? this.state[`attention_comment_${row.index}`]
                            : v?.[`attention_comment_${row.index}`]
                        }
                      />
                    </VehiclePropertyLoadable>
                  )}
                </div>

                <div className={styles.buttons}>
                  {/* <ButtonComponent
                    style={'ButtonSoftPrimary'}
                    onClick={() => {
                      this.props.setProperty(`attention_comment_${row.index}`, this.state[`attention_comment_${row.index}`]);
                    }}
                  >
                    <Check />
                  </ButtonComponent> */}
                  <ButtonComponent
                    style={'ButtonSoftDelete'}
                    onClick={() => {
                      this.props.deleteProperty(`attention_comment_${row.index}`);
                      this.setState({ [`attention_comment_${row.index}`]: '' });
                    }}
                  >
                    <CircleTimes />
                  </ButtonComponent>
                </div>
              </div>
            </HBox>
          </VBox>
        ))}
        <div className="mb-2">
          <ButtonComponent
            style={'ButtonSoftPrimary'}
            onClick={() => this.addAttentionImage(rows[rows?.length - 1]?.index + 1 || 0, true)}
          >
            <Plus />
            {this.lbl('add')}
          </ButtonComponent>
        </div>
      </VBox>
    );
    return null;
  }

  renderImportPhotos(option) {
    const v = this.props.vehicle;
    let photoIndex = option == 'generalPhotos' ? 'photo_interior_general_0' : 'photo_interior_import_0';

    if (!v) return null;
    if (!this.state.mileage) {
      this.setState({ mileage: getPropByName(v, 'mileage') });
    }
    const vehiclePurpose = getPropByName(this.vehicle, 'vehicle_purpose');
    let extraPhotos = [];
    let defaults = [];
    let rows = [];

    if (vehiclePurpose === 'passenger') {
      defaults = WS2_1_IMPORT_PHOTOS_PASSENGER;
    }

    if (vehiclePurpose === 'commercial') {
      defaults = WS2_1_IMPORT_PHOTOS_COMMERCIAL;
    }

    if (option === 'generalPhotos') {
      defaults = WS2_1_GENERAL_PHOTOS;
    }

    if (option === 'tesla_additional_info') {
      defaults = WS2_1_TESLA_ADDITIONAL_PHOTOS;
    }
    defaults?.map((type, i) => {
      let photos = v.documents?.filter(d => {
        return d?.type?.indexOf(`${photoIndex} ${type}`) === 0;
      });

      return rows.push({
        index: i,
        placeholder: type,
        photos,
      });
    });

    if (option == 'generalPhotos') {
      extraPhotos = v.documents?.filter((d, index) => {
        return d.type?.includes(`${photoIndex} extra_`);
      });
      extraPhotos?.map((d, index) => {
        return rows.push({
          placeholder: `extra_${index + 1}`,
          photos: [d],
        });
      });
    }

    return (
      <>
        <div key="import_photos" className="grid-container">
          {rows.map(row => {
            return (
              <div key={row?.placeholder}>
                <div className="cell">
                  {row?.photos?.length > 0 ? (
                    <VBox center className="import-photo-wrapper">
                      {row?.photos?.map(doc => this.renderImportPhoto(doc))}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  ) : (
                    <VBox
                      center
                      className="import-photo-wrapper"
                      onClick={() => {
                        this.addImportImage(0, row.placeholder, option);
                      }}
                    >
                      {this.renderPlaceholderImage(vehiclePurpose, row?.placeholder, option)}
                      <span>{this.lbl(`vehicle.import_photos.${row?.placeholder}`)}</span>
                    </VBox>
                  )}
                </div>
              </div>
            );
          })}
          {option == 'generalPhotos' && (
            <div className="cell">
              <HBox
                vCenter
                className="import-photo-wrapper extra-photo-wrapper justify-content-center"
                onClick={() => this.addImportImage(0, `extra_${extraPhotos?.length}`, option)}
              >
                <div style={{ fontSize: '26px' }}>
                  <Plus />
                </div>
              </HBox>
            </div>
          )}
        </div>
        {!option && (
          <FormField key={`import-input-0`} label={this.lbl('vehicle.import_photos.mileage_label')}>
            <Input
              full
              key={`mileage`}
              name={`mileage`}
              onChange={this.onCommentChange}
              value={this.state[`mileage`]}
              rightDecoration={
                <>
                  <Button
                    small
                    disabled={this.props.workUpdate}
                    onClick={() => {
                      this.props.setProperty(`mileage`, this.state[`mileage`]);
                    }}
                  >
                    {this.props.workUpdate ? <Loader small="true" /> : <Check />}
                  </Button>
                  <Button
                    warning
                    disabled={this.props.workUpdate}
                    small
                    onClick={() => {
                      this.props.deleteProperty(`mileage`);
                      this.setState({ [`mileage`]: '' });
                    }}
                  >
                    {this.props.workUpdate ? <Loader small="true" /> : <Times />}
                  </Button>
                </>
              }
            />
          </FormField>
        )}
      </>
    );
    return null;
  }
}

WS2_1_InteriorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    allOptions: selectAllOptions(),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    workUpdate: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    workAction: selectWork(REQUEST_KANBAN_BOARD_PERFORM_ACTION),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    toggleOption(optionId, state, callback) {
      let fn = state ? addVehicleOption : removeVehicleOption;
      dispatch(fn(ownProps.cell.vehicle.id, optionId, callback));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
    imageUpload(documentDto, work, callback) {
      dispatch(addDocument(ownProps.cell.vehicle.id, 'vehicle', documentDto, callback, work));
    },
    deleteDocument(id, callback) {
      dispatch(deleteDocument(ownProps.cell.vehicle.id, 'vehicle', id, callback));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.cell.vehicle.id, name));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WS2_1_Interior = compose(withConnect, withRouter)(WS2_1_InteriorComp);
